import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileDown, ArrowLeft, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError, API } from "@/lib/api";

import "@/styles/legal.css";

export default function ReglementInterieurPage() {
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/legal/reglement_interieur")
            .then((r) => setDoc(r.data))
            .catch((err) => toast.error(formatApiError(err)))
            .finally(() => setLoading(false));
    }, []);

    const downloadPdf = async () => {
        try {
            const r = await fetch(`${API}/legal/reglement_interieur/pdf`);
            if (!r.ok) throw new Error("Téléchargement impossible");
            const blob = await r.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `reglement-interieur-v${doc?.version || "1.0"}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
            toast.success("PDF téléchargé");
        } catch (err) {
            toast.error(err.message);
        }
    };

    if (loading) {
        return <div className="mx-auto max-w-3xl px-6 py-24 text-center text-brand-smoke">Chargement…</div>;
    }
    if (!doc) {
        return <div className="mx-auto max-w-3xl px-6 py-24 text-center text-brand-smoke">Document indisponible.</div>;
    }

    return (
        <div className="bg-[#FBF8F3] min-h-screen pb-20" data-testid="page-reglement-interieur">
            <div className="mx-auto max-w-4xl px-6 pt-8">
                <Link to="/" className="inline-flex items-center gap-1 text-sm text-brand-smoke hover:text-brand-orange">
                    <ArrowLeft className="h-3.5 w-3.5" /> Retour à l'accueil
                </Link>
            </div>
            <div className="mx-auto mt-6 max-w-4xl rounded-3xl bg-white p-10 shadow-premium md:p-14">
                <div className="flex flex-wrap items-start justify-between gap-3">
                    <div className="text-[11px] font-semibold uppercase tracking-[0.25em] text-brand-orange">
                        Document légal · Qualiopi
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="inline-flex items-center gap-1 rounded-full bg-brand-orange/10 px-3 py-1 text-[11px] font-semibold text-brand-orange">
                            <ShieldCheck className="h-3 w-3" /> Version {doc.version}
                        </span>
                        <button
                            onClick={downloadPdf}
                            data-testid="reglement-pdf-btn"
                            className="inline-flex items-center gap-1.5 rounded-full bg-brand-ink px-4 py-1.5 text-xs font-semibold text-white hover:bg-[#222]"
                        >
                            <FileDown className="h-3 w-3" /> Télécharger le PDF
                        </button>
                    </div>
                </div>

                <div
                    className="mt-8"
                    data-testid="reglement-content"
                    dangerouslySetInnerHTML={{ __html: doc.html }}
                />
            </div>
        </div>
    );
}
